import { ITranslation } from '@lmnop/web-core';

export interface IAngularTranslation extends ITranslation {
    waitUntilInitialized(): Promise<any>;
}
